import { render, staticRenderFns } from "./PTOCreationModal.vue?vue&type=template&id=f2afe2c2&scoped=true&"
import script from "./PTOCreationModal.vue?vue&type=script&lang=ts&"
export * from "./PTOCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2afe2c2",
  null
  
)

export default component.exports